import { RESOURCE_TAG_FAVORITE } from "@cohesive/api-client";
import type { BrowserItem } from "./homeBrowserTypes";

/** Star/pin state per kind — resource tags for most, is_starred for chats. */
export function browserItemStarred(item: BrowserItem): boolean {
  switch (item.kind) {
    case "canvas":
    case "file":
    case "skill":
      return !!item.data.tags?.includes(RESOURCE_TAG_FAVORITE);
    case "chat":
      return item.data.is_starred;
  }
}

/** Unread indicator — chats only. */
export function browserItemUnread(item: BrowserItem): boolean {
  return item.kind === "chat" && !item.data.is_read;
}

/**
 * Owning workspace, for the home list's Workspace column. Chats carry it on
 * the nested flow session; skills aren't workspace-scoped at all. Undefined
 * means "no workspace to show", which the column renders as an em dash.
 */
export function browserItemWorkspaceId(item: BrowserItem): string | undefined {
  switch (item.kind) {
    case "canvas":
    case "file":
      return item.data.workspace_id;
    case "chat":
      return item.data.flow_session?.workspace_id;
    case "skill":
      return undefined;
  }
}

/**
 * Owner label for the list view's Owner column. Skills and chats are always
 * the current user's ("You"); canvases resolve through the callers' user map
 * (see useCanvasCardActions.getCreator); file records carry no creator, so
 * files return undefined and the cell renders an em dash.
 */
export function browserItemOwnFallbackName(
  item: BrowserItem,
): string | undefined {
  switch (item.kind) {
    case "skill":
    case "chat":
      return "You";
    case "canvas":
    case "file":
      return undefined;
  }
}
